import type { CashDenominationCount } from '../../types/domain';

export type CashDenomination = {
  denominationCents: number;
  label: string;
  kind: 'bill' | 'coin';
};

export const MXN_CASH_DENOMINATIONS: CashDenomination[] = [
  { denominationCents: 100000, label: '$1,000', kind: 'bill' },
  { denominationCents: 50000, label: '$500', kind: 'bill' },
  { denominationCents: 20000, label: '$200', kind: 'bill' },
  { denominationCents: 10000, label: '$100', kind: 'bill' },
  { denominationCents: 5000, label: '$50', kind: 'bill' },
  { denominationCents: 2000, label: '$20', kind: 'bill' },
  { denominationCents: 2000, label: '$20', kind: 'coin' },
  { denominationCents: 1000, label: '$10', kind: 'coin' },
  { denominationCents: 500, label: '$5', kind: 'coin' },
  { denominationCents: 200, label: '$2', kind: 'coin' },
  { denominationCents: 100, label: '$1', kind: 'coin' },
  { denominationCents: 50, label: '$0.50', kind: 'coin' },
  { denominationCents: 20, label: '$0.20', kind: 'coin' },
  { denominationCents: 10, label: '$0.10', kind: 'coin' },
];

export const normalizeCashBreakdown = (items: CashDenominationCount[]): CashDenominationCount[] => items
  .map((item) => ({
    denominationCents: Math.max(0, Math.round(Number(item.denominationCents) || 0)),
    quantity: Math.max(0, Math.floor(Number(item.quantity) || 0)),
    kind: item.kind === 'coin' ? 'coin' as const : 'bill' as const,
  }))
  .filter((item) => item.denominationCents > 0 && item.quantity > 0);

export const cashBreakdownTotal = (items: CashDenominationCount[]) => normalizeCashBreakdown(items)
  .reduce((total, item) => total + item.denominationCents * item.quantity, 0);
